export const CONSTANTS = {
  EXPIRY_1_YEAR: 525600,  // 1 year, 12 months, 365 days, 8760 hours, 525,600 minutes
  DEFAULT_EXPIRY_1_MONTH: 40320,  // (in min) 24H * 60M * 28D
  USERS_ON_GROWW_IN_LACS: 400,
  USERS_ON_GROWW_IN_MILLIONS: 40,
  TEAM_MEMBERS_IN_GROWW: 1000,
  GROWW_CURRENT_RATING: 4.5,
  SEARCH_EXPIRY_TIME_IN_MIN: 1,
  CURRENT_YEAR: new Date().getFullYear().toString(),
  TWENTY_HOURS_EXPIRY_TIME: 1200,
  SEVEN_DAYS_IN_MINS: 10080,
  TWO_DAYS_IN_MINS: 2880,
  ONE_DAY_IN_MINS: 1440,
  ONE_HOUR_IN_MINUTES: 60,
  TWO_HOUR_IN_MINS: 120,
  SIX_HOUR_IN_MINS: 360,
  THIRTY_MINUTES: 30,
  FIVE_MINUTES: 5,
  EXPIRY_15_MINUTES: 15,
  EXPIRY_10_MINUTES: 10,
  ONE_MINUTE: 1,
  TWENTY_HOURS_IN_MINS: 1200,
  ONE_HOUR_IN_MINS: 60,
  FIFTEEN_MINUTES: 15,
  TEN_MINUTES: 10,
  THIRTY_DAYS_IN_MINS: 43200,
  THREE_DAYS_IN_MINS: 4320,
  THREE_HOUR_IN_MINS: 180,

  // persisted
  USER_UUID: 'dsocsweuvhapdubdpotsgbsobhb',
  TRADING_VIEW_PREFERENCE: 'TRADING_VIEW_PREFERENCE',
  USER_INDICES_ORDER: 'USER_INDICES_ORDER',
  UI_THEME: 'bfdskfds',

  // auth
  AUTH_SESSION_ID: 'AUTH_SESSION_ID',
  AUTHORIZATION: 'lhtndhgfd',
  REFRESH_TOKEN: 'alnuyoasdasloppes',
  PIN_TOKEN: 'arkeyt473rfh7834cd',
  TWO_FACTOR_PIN_ALREADY_SET: 'fsdyuyurewdfi896k7g',
  N_KEY_SEED: 'N_KEY_SEED',
  SOCKET_TOKEN: 'SOCKET_TOKEN',

  //others
  IS_WEBVIEW_ACTIVE: 'IS_WEBVIEW_ACTIVE',

  // grobot
  GROBOT_HAS_INTERACTED: 'grobot_has_interacted'
};
